import { t } from 'i18next';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { useNavigation } from '#/hooks';
import { useOnNavigateAway } from '#/hooks/useOnNavigateAway';
import { Path } from '#/service/routes';
import { useAuthentication } from '#/store/auth';

import { PageHeading } from '../common';
import { LoginStandard } from './LoginStandard';
import { LoginModal } from './styled';

interface Props {
  closeModal: () => void;
}

/**
 * Login component responsible for rendering a standard (email + password) login form in the modal to be used within the app
 */
export const LoginStandardPopup: FC<Props> = ({ closeModal }) => {
  const { goBack } = useNavigation('LoginStandard');
  const location = useLocation();

  const { isRegistrationEnabled, isForgotPasswordEnabled } =
    useAuthentication();

  useOnNavigateAway(closeModal);

  const handleNavigation = () => {
    // use case: search page -> login (just a popup) -> register (navigates to page) -> login (popup is over the registration page now) -> close with 'X' button -> navigate back to the starting page (not necessarily home).
    if (location.pathname === Path.Registration) {
      goBack();
    }
  };

  const handleCloseAndNavigate = () => {
    handleNavigation();
    closeModal();
  };

  return (
    <LoginModal
      closeOnEsc
      closeOnOverlayClick
      isOpen
      onClose={handleCloseAndNavigate}
    >
      <PageHeading>{t('login.pageTitle')}</PageHeading>
      <LoginStandard
        hideForgotPassword={!isForgotPasswordEnabled}
        hideRegister={!isRegistrationEnabled}
        onCancel={closeModal}
        onSuccess={handleCloseAndNavigate}
      />
    </LoginModal>
  );
};

LoginStandardPopup.displayName = 'LoginStandardPopup';
